import API, { API_URL } from 'api/API';
import { ApiResult } from 'libs/types';

import { getUrlQueryString } from 'libs/utils';

interface GetServerTimeApiParams {
  obsId: number;
}

interface GetServerTimeApiResult extends ApiResult {
  date: string;
  time: string;
}

async function getServerTimeApi({ obsId }: GetServerTimeApiParams): Promise<GetServerTimeApiResult> {
  const queryString = getUrlQueryString({
    obs_id: obsId,
  });
  const { data } = await API.get(`${API_URL.SKYW.GET_SERVER_TIME}?${queryString}`);

  return data;
}

export default getServerTimeApi;
